import React from 'react';
import { renderToString } from 'react-dom/server';

import makeChartConfig from '../../../../../components/Chart/LineChart';
import { zooming } from '../../../configs/chart-config';
import { format } from '../../../../../utils/date';
import { numberToHumanChart } from '../../../../../utils/formatter';

const postfixByMetric = {
  average_time_spent_per_dau: ' minutes',
};

const tooltipPrecisionConfig = { precision: 1 };

const formatByGranularity = (value, granularity) => {
  if (granularity === 'daily') {
    return format(value, 'MMM DD, YYYY');
  }

  return format(value, 'MMM`YY');
};

export const appImpactChartConfig = ({ metric, floor, ceiling, granularity }) =>
  makeChartConfig({
    chartOptions: {
      type: 'spline',
      spacing: [10, 0, 0, 0],
      height: 292,
      zooming,
    },
    yAxisOptions: {
      title: null,
      floor,
      ceiling,
      minPadding: 0.01,
      maxPadding: 0.01,
      startOnTick: true,
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
      labels: {
        reserveSpace: true,
        style: {
          color: '#848EA1',
          fontSize: 12,
        },
        formatter() {
          return `${numberToHumanChart(this.value)}`;
        },
      },
    },
    xAxisOptions: {
      tickLength: 0,
      lineWidth: 1,
      lineColor: '#EDF0F5',
      maxPadding: 0.05,
      crosshair: {
        color: '#E1E5EB',
        width: 1,
      },

      type: 'datetime',
      showFirstLabel: true,
    },
    xAxisLabels: {
      formatter() {
        if (this.isFirst || this.isLast) {
          return `<span class="text-nowrap">${format(this.value, 'MMM ‘YY')}</span>`;
        }
        return '';
      },
      style: {
        color: '#848EA1',
        fontSize: 12,
        textOverflow: 'none',
        width: 40,
      },
      useHTML: true,
    },
    tooltipOptions: {
      borderWidth: 0,
      padding: 0,
      shared: true,
      valueDecimals: 2,
      useHTML: true,
      outside: true,
      className: 'quick-view-tooltip',
      formatter() {
        if (!Array.isArray(this.points)) return false;

        const pointOptions = this.points[0].point.options;
        const isPartialElem = pointOptions.isPartial;

        const renderTooltipContent = (rowsContent) =>
          renderToString(
            <div
              style={{
                minWidth: '190px',
                borderRadius: '8px',
                border: '1px solid #E1E5EB',
                padding: '12px 16px',
                backgroundColor: '#fff',
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.08)',
              }}
            >
              <table className="table">
                <tr>
                  <td className="text-left text-black text-12 p-l-0 p-b-0 pr-md">
                    {formatByGranularity(this.x, granularity)} {isPartialElem && '(Partial Period)'}
                  </td>
                </tr>
                {rowsContent}
              </table>
            </div>
          );

        return renderTooltipContent(
          this.points.map((point) => (
            <tr key={point.series.name}>
              <td className="text-left text-black text-14 p-l-0 p-b-0 pr-md">
                <div className="text-truncate text-black text-14" style={{ maxWidth: '100%' }}>
                  <span
                    className="tooltip-bubble-marker"
                    style={{
                      backgroundColor: point.series.color,
                      borderColor: point.series.color,
                    }}
                  />
                  <span>{point.series.name}</span>
                </div>
              </td>
              <td className="text-right text-black text-14 p-l-0 p-b-0">
                {point.isStub
                  ? '—'
                  : `${numberToHumanChart(point.y, tooltipPrecisionConfig)}${
                      postfixByMetric[metric] || ''
                    }`}
              </td>
            </tr>
          ))
        );
      },
    },
  });
